// import * as prismic from "@prismicio/client";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { PRISMIC_API_KEY, PRISMIC_API_URL, PRISMIC_REPO_NAME } from "@config/constants";
import axios from "axios";
import { isEmpty, isNil } from "lodash";
var UPDATE_INTERVAL = 1000 * 60 * 60 * 1; // 1 hour
function convertSingleItemArrays(data) {
    if (Array.isArray(data) && data.length === 1) {
        return convertSingleItemArrays(data[0]);
    }
    if (Array.isArray(data)) {
        return data.map(convertSingleItemArrays);
    }
    if (typeof data === "object" && data !== null) {
        for(var key in data){
            if (!isNil(data[key])) {
                data[key] = convertSingleItemArrays(data[key]);
            } else {
                delete data[key];
            }
        }
    }
    return data;
}
var PrismicClient = /*#__PURE__*/ function() {
    "use strict";
    function PrismicClient() {
        var _this = this;
        _class_call_check(this, PrismicClient);
        _define_property(this, "responseMemo", {});
        _define_property(this, "lastUpdate", {});
        _define_property(this, "ERRORS", {
            NO_MASTER_REF: "NO_MASTER_REF",
            NO_RESPONSE: "NO_RESPONSE"
        });
        _define_property(this, "_fetch", function(url) {
            return axios({
                method: "GET",
                url: url,
                headers: _this.headers
            });
        });
        if (!this.hasPrismic()) {
            console.error("Prismic API key or repository name is missing");
            return;
        }
        this.baseUrl = "".concat(PRISMIC_API_URL, "/api/v2");
        this.headers = {
            Accept: "application/json"
        };
    }
    _create_class(PrismicClient, [
        {
            key: "hasPrismic",
            value: function hasPrismic() {
                return !isEmpty(PRISMIC_API_KEY) && !isEmpty(PRISMIC_REPO_NAME);
            }
        },
        {
            key: "memoisedFetchPrismic",
            value: function memoisedFetchPrismic(type) {
                var filterStrategy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(data) {
                    return data;
                };
                var _this = this;
                return _async_to_generator(function() {
                    var searchParams, _tmp, url, data;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isEmpty(_this.responseMemo[type]) && Date.now() - _this.lastUpdate[type] < UPDATE_INTERVAL) {
                                    return [
                                        2,
                                        _this.responseMemo[type]
                                    ];
                                }
                                _tmp = {};
                                return [
                                    4,
                                    _this.getMasterRef()
                                ];
                            case 1:
                                searchParams = (_tmp.ref = _state.sent(), _tmp.q = '[[at(document.type, "'.concat(type, '")]]'), _tmp.access_token = PRISMIC_API_KEY, _tmp);
                                url = "".concat(_this.baseUrl, "/documents/search?").concat(new URLSearchParams(searchParams));
                                return [
                                    4,
                                    _this._fetch(url).catch(function() {
                                        throw new Error(_this.ERRORS.NO_RESPONSE);
                                    })
                                ];
                            case 2:
                                data = _state.sent().data;
                                _this.responseMemo[type] = data.results.map(function(res) {
                                    return filterStrategy(res === null || res === void 0 ? void 0 : res.data);
                                });
                                _this.lastUpdate[type] = Date.now();
                                return [
                                    2,
                                    _this.responseMemo[type]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSubscriptions",
            value: function getSubscriptions() {
                var countryCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ALL";
                var _this = this;
                return _async_to_generator(function() {
                    var subscriptionItems, fallbackData, data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sub;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.memoisedFetchPrismic("subscriptions", convertSingleItemArrays)
                                ];
                            case 1:
                                subscriptionItems = _state.sent();
                                fallbackData = null;
                                data = null;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = subscriptionItems[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        sub = _step.value;
                                        if (sub.country_code === "ALL") {
                                            fallbackData = sub;
                                            continue;
                                        }
                                        if (sub.country_code === countryCode) {
                                            data = sub;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    data || fallbackData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAllSubscriptions",
            value: function getAllSubscriptions() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.memoisedFetchPrismic("subscriptions", convertSingleItemArrays)
                        ];
                    });
                })();
            }
        },
        {
            key: "getStbDetails",
            value: function getStbDetails() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.memoisedFetchPrismic("stb_details")
                        ];
                    });
                })();
            }
        },
        {
            key: "getPrivacyPolicy",
            value: function getPrivacyPolicy() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.memoisedFetchPrismic("privacy_policy")
                        ];
                    });
                })();
            }
        },
        {
            key: "getAppGuide",
            value: function getAppGuide() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.memoisedFetchPrismic("applications_guide")
                        ];
                    });
                })();
            }
        },
        {
            key: "getTOS",
            value: function getTOS() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _this.memoisedFetchPrismic("terms")
                        ];
                    });
                })();
            }
        },
        {
            key: "getFaq",
            value: function getFaq() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.memoisedFetchPrismic("faq")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()[0]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNotifications",
            value: function getNotifications() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.memoisedFetchPrismic("subscription_notification")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()[0]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMasterRef",
            value: function getMasterRef() {
                var _this = this;
                return _async_to_generator(function() {
                    var _data_refs_find, data, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._fetch(_this.baseUrl)
                                ];
                            case 1:
                                data = _state.sent().data;
                                return [
                                    2,
                                    (_data_refs_find = data.refs.find(function(ref) {
                                        return ref.id === "master";
                                    })) === null || _data_refs_find === void 0 ? void 0 : _data_refs_find.ref
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error(_this.ERRORS.NO_MASTER_REF);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PrismicClient;
}();
export default new PrismicClient();
